import CustomButton from "components/CustomButton/CustomButton";
import RequiredInformationForm from "components/RequiredInformationForm/RequiredInformationForm";
import { Column, Row } from "components/styles";

const Footer = ({
    save,
    cancel,
    completedForm
}) => {
    return (
        <Column align="flex-end">
            <RequiredInformationForm/>
            <Row>
                <CustomButton 
                    variant="secondary" 
                    size="small"
                    width="110px"
                    text="Cancelar"
                    onClick={cancel}/>
                <CustomButton 
                    text="Guardar"
                    size="small"
                    width="110px"
                    onClick={save}
                    disabled={!completedForm()}/>
            </Row>
        </Column>
    );
}

export default Footer;